define('plugin/invoice/model/InvoiceLineModel',['require','backbone'],function (require) {

    var Backbone = require('backbone');

    /**
     * Invoice line model
     *
     * @class InvoiceLineModel
     */
    return Backbone.Model.extend({

        defaults: {
            id: null,
            name: '',
            qty: 0,
            price: 0,
            discount_ratio: 0,
            tax: null,
            tax_amount: 0,
            tax_ratio: 0,
            type: '',
            booking_ids: null,
            product_id: null,
            membership_id: null
        }

    });

});
